module.exports = __webpack_public_path__ + "static/media/oxygen mall render 02-mobile.5af88758.webp";